import {
  DownloadButtonAttributes,
  DownloadButtonType,
} from "@routes/Keyword/templates/AseanInsights/utils/types";

export const DOWNLOAD_BUTTON_ATTRIBUTES: Record<
  DownloadButtonType,
  DownloadButtonAttributes
> = {
  hero: {
    className:
      "w-full bg-blue-175 text-base font-semibold hover:bg-blue-300 group-hover:bg-blue-300 mb-4 lg:mb-6",
    text: "Download Report",
    type: "hero",
    gaEvent: {
      event: "custom_event",
      eventCategory: "asean intelligence report",
      eventAction: "click",
      eventLabel: "hero::download 2026 report",
    },
  },
  widget: {
    className:
      "w-full bg-blue-175 text-xs font-semibold group-hover:bg-blue-300",
    text: "Download",
    type: "widget",
    gaEvent: {
      event: "custom_event",
      eventCategory: "asean intelligence report",
      eventAction: "click",
      eventLabel: "widget::download",
    },
  },
};
